import {
	IStatementPayloadBuilder,
	StatementPayload,
	ActorParams,
	AuthorityParams,
	ObjectParams,
	ContextParams,
  	ResultParams,
} from "../types";

export class StatementPayloadBuilder implements IStatementPayloadBuilder {
	private payload: StatementPayload;

	constructor() {
		this.payload = {
			verb: {
				id: "",
			},
			object: {
				objectType: "Activity",
				id: "",
			},
			actor: {
				objectType: "Agent",
				account: {
					homePage: "",
					name: "",
				},
			},
			timestamp: new Date().toISOString(),
			version: "1.0.0",
		};
	}

	public setVerb(verb: string): StatementPayloadBuilder {
		this.payload.verb.id = verb.startsWith("http")
			? verb
			: "https://api.zanichelli.it/xapi/verbs/" + verb;
		return this;
	}

	public setContext(
		platform: string,
		context?: ContextParams
	): StatementPayloadBuilder {
		if (!context) return this;

		this.payload.context = { platform: platform };

		if (context.extensions) {
			this.payload.context.extensions = context.extensions;
		}

		if (context.statement) {
			this.payload.context.statement = context.statement;
		}

		if (context.activities) {
			this.payload.context.contextActivities =
				context.activities === true
					? { parent: [{ id: window.location.origin }] }
					: context.activities;
		}
		return this;
	}

	public setObject(obj: ObjectParams): StatementPayloadBuilder {
		this.payload.object.id = obj.id;
		if (obj.type) this.payload.object.objectType = obj.type;
		if (obj.definition) this.payload.object.definition = obj.definition;
		return this;
	}

	public setActor(
		homepage: string,
		actor: ActorParams
	): StatementPayloadBuilder {
		if (actor.name) this.payload.actor.name = actor.name;
		if (actor.openId) this.payload.actor.openid = actor.openId;

		this.payload.actor.account.homePage = homepage;
		this.payload.actor.account.name = actor.accountName;
		return this;
	}

	public setAuthority(auth?: AuthorityParams): StatementPayloadBuilder {
		if (!auth) return this;

		this.payload.authority = {
			name: "Zanichelli",
			mbox: auth.mbox ?? "mailto:info@Zanichelli.it",
		};

		if (auth.objectType) this.payload.authority.objectType = auth.objectType;
		return this;
	}

  public setResult(result?: ResultParams): StatementPayloadBuilder {
    if (!result) return this;
  
	this.payload.result = { ...result };
    return this;
  }

	public build(): StatementPayload {
		return this.payload;
	}
}
